import _replaceAllInstanceProperty from "@babel/runtime-corejs3/core-js/instance/replace-all";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import GenericModal from "@Shared/components/modals/generic-modal.vue";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import vSelectField from "@Shared/components/form-elements/fields/v-select-field.vue";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import { defineComponent, ref, toRefs, nextTick, computed } from "@vue/composition-api";
import { autoComposeEmail } from "../../../application/api/application-api";
import { cloneDeep } from "lodash";
import { useAccountStoreGetters } from "@Broker/js/modules/main/store/account/account-helpers";
import * as AccountGetters from "@Broker/@Modules/main/store/account/account-getters";
import { useAccountStoreActions } from "@Broker/js/modules/main/store/account/account-helpers";
import * as AccountActions from "@Broker/@Modules/main/store/account/account-actions";
import * as BoardActions from "@Broker/@Modules/clients/board/store/board-actions";
import { useBoardStoreActions } from "@Broker/@Modules/clients/board/store/board-helpers";
import AiEmailTemplatesDropdown from "./generate-ai-components/ai-email-templates-dropdown.vue";
import AiEmailTemplateModal from "./generate-ai-components/ai-email-template-modal.vue";
import { useI18n } from "vue-i18n-composable";
import { showToast } from "@Shared/utils/constants";
import { getSavedEmailPrompts } from "@Broker/@Modules/clients/applications/application/api/application-api";
export default defineComponent({
  name: "GenerateEmailModal",
  components: {
    GenericModal,
    SimpleButton,
    vSelectField,
    MaterialInput,
    AiEmailTemplatesDropdown,
    AiEmailTemplateModal
  },
  props: {
    buttonText: {
      type: String,
      default: "save"
    },
    clientProfile: {
      type: Object,
      required: true
    },
    applicationId: {
      type: Number,
      default: null
    },
    emailSignature: {
      type: String,
      default: ""
    },
    showToolTip: {
      type: Boolean,
      default: true
    }
  },
  setup(props, {
    emit
  }) {
    const {
      t
    } = useI18n();
    const {
      buttonText,
      clientProfile,
      emailSignature,
      applicationId
    } = toRefs(props);
    const modalOpened = ref(false);
    const generateEmailModal = ref();
    let textareaValue = ref("");
    const customPrompt = ref("");
    const isErrorState = ref(false);
    const modalType = ref("");
    const aiEmailTemplateModal = ref();
    const savedPrompts = ref([]);
    const savedPromptsLoading = ref(false);
    const showLoadOption = computed(() => savedPrompts.value.length > 0);
    const purposeOptions = ref([{
      text: t("email.custom.describeYourEmail"),
      value: 12
    }, {
      text: t("global.actions.welcomeNewClient"),
      value: 0
    }, {
      text: t("global.actions.newApplicationReceived"),
      value: 1
    }, {
      text: t("global.actions.upcomingRenewal"),
      value: 2
    }, {
      text: t("global.actions.annualCheckIn"),
      value: 3
    }, {
      text: t("global.actions.mortgages101"),
      value: 4
    }]);
    const emailSubjects = ref([{
      subject: t("global.actions.welcomeNewClientSubject")
    }, {
      subject: t("global.actions.newApplicationReceivedSubject")
    }, {
      subject: t("global.actions.upcomingRenewal")
    }, {
      subject: t("global.actions.annualCheckIn")
    }, {
      subject: t("global.actions.mortgages101")
    }]);
    const toneOptions = ref([{
      text: "Professional",
      value: "professional"
    }, {
      text: "Casual",
      value: "casual"
    }, {
      text: "Funny",
      value: "funny"
    }]);
    const lengthOptions = ref([{
      text: "Short",
      value: "short"
    }, {
      text: "Medium",
      value: "medium"
    }, {
      text: "Long",
      value: "long"
    }]);
    const languageOptions = ref([{
      text: "English",
      value: "en-CA"
    }, {
      text: "French",
      value: "fr-CA"
    }]);
    const clientId = ref("");
    const selectedPurpose = ref(12);
    const selectedEmailSubject = ref("");
    const {
      GET_AI_EMAILS_DEFAULT_SETTINGS
    } = useAccountStoreGetters([AccountGetters.GET_AI_EMAILS_DEFAULT_SETTINGS]);
    const aiEmailDefaultSettings = cloneDeep(GET_AI_EMAILS_DEFAULT_SETTINGS.value);
    const {
      tone = "professional",
      length = "short",
      language = "en-CA"
    } = aiEmailDefaultSettings || {};
    const selectedTone = ref(tone);
    const selectedLength = ref(length);
    const selectedLanguage = ref(language);
    const loading = ref(false);
    const {
      UPDATE_AI_EMAIL_PREFERENCES
    } = useAccountStoreActions([AccountActions.UPDATE_AI_EMAIL_PREFERENCES]);
    const aiEmailPreferences = ref(aiEmailDefaultSettings);
    const loadSavedPrompts = async () => {
      savedPromptsLoading.value = true;
      try {
        const prompts = await getSavedEmailPrompts();
        savedPrompts.value = Array.isArray(prompts["prompts"]) ? prompts["prompts"] : [];
      } catch (error) {
        savedPrompts.value = [];
      } finally {
        savedPromptsLoading.value = false;
      }
    };
    const openModal = () => {
      var _generateEmailModal$v;
      modalOpened.value = true;
      selectedPurpose.value = 12;
      (_generateEmailModal$v = generateEmailModal.value) == null ? void 0 : _generateEmailModal$v.show();
      loadSavedPrompts();
    };
    const closeModal = () => {
      var _generateEmailModal$v2;
      (_generateEmailModal$v2 = generateEmailModal.value) == null ? void 0 : _generateEmailModal$v2.hide();
      textareaValue.value = "";
      customPrompt.value = "";
      selectedPurpose.value = 12;
      selectedEmailSubject.value = "";
      setDefaultSettings();
    };
    const setDefaultSettings = () => {
      if (aiEmailDefaultSettings.length) {
        selectedTone.value = aiEmailDefaultSettings.tone;
        selectedLanguage.value = aiEmailDefaultSettings.language;
        selectedLength.value = aiEmailDefaultSettings.length;
      } else {
        selectedTone.value = "professional";
        selectedLanguage.value = "en-CA";
        selectedLength.value = "short";
      }
    };
    const selectMailPurpose = async val => {
      selectedPurpose.value = val.value;
      if (val.value === 12) {
        loadSavedPrompts();
      }
      if (selectedPurpose.value < emailSubjects.value.length) {
        selectedEmailSubject.value = emailSubjects.value[selectedPurpose.value].subject.toString();
      } else {
        selectedEmailSubject.value = "";
      }
    };
    const handleGenerateEmail = async () => {
      const emailSettings = {
        purpose: selectedPurpose.value,
        tone: selectedTone.value,
        language: selectedLanguage.value,
        length: selectedLength.value,
        customPrompt: customPrompt.value
      };
      textareaValue.value = "loading";
      const {
        clientProfileId,
        generatedEmail,
        subject,
        isError
      } = await autoComposeEmail(clientProfile.value, emailSettings);
      clientId.value = clientProfileId;
      if (isError) {
        isErrorState.value = true;
        textareaValue.value = generatedEmail;
        return;
      }
      isErrorState.value = false;
      textareaValue.value = generatedEmail;
      if (selectedPurpose.value === 12 && subject) {
        selectedEmailSubject.value = subject;
      }
      if (emailSignature.value) {
        var _context, _context2;
        textareaValue.value += "\n" + _replaceAllInstanceProperty(_context = _replaceAllInstanceProperty(_context2 = emailSignature.value).call(_context2, "<div>", "\n")).call(_context, "<br>", "\n").replace(/<\/?[^>]+(>|$)/g, "");
      }
    };
    const handleSetDefault = async () => {
      loading.value = true;
      await nextTick(() => {
        aiEmailPreferences.value.tone = selectedTone.value;
        aiEmailPreferences.value.language = selectedLanguage.value;
        aiEmailPreferences.value.length = selectedLength.value;
        UPDATE_AI_EMAIL_PREFERENCES(aiEmailPreferences.value);
      });
      loading.value = false;
    };
    const {
      SEND_EMAIL_TO_CLIENT
    } = useBoardStoreActions([BoardActions.SEND_EMAIL_TO_CLIENT]);
    const handleButton = () => {
      var _context3;
      if (buttonText.value === "save") emit("save-email", _replaceAllInstanceProperty(_context3 = textareaValue.value).call(_context3, "\n", "<br />"), selectedEmailSubject.value);else {
        sendEmail();
      }
      closeModal();
    };
    const sendEmail = async () => {
      var _context4, _context5, _applicationId$value, _applicationId$value2;
      const email = {
        body: _replaceAllInstanceProperty(_context4 = textareaValue.value).call(_context4, "\n", "<br />"),
        subject: selectedEmailSubject.value,
        cc: [],
        bcc: [],
        attachments: [],
        to: clientProfile.value.email,
        toList: [clientProfile.value.email],
        html: _replaceAllInstanceProperty(_context5 = textareaValue.value).call(_context5, "\n", "<br />"),
        emailPurpose: selectedPurpose.value,
        applicationId: (_applicationId$value = applicationId == null ? void 0 : applicationId.value) != null ? _applicationId$value : null
      };
      await SEND_EMAIL_TO_CLIENT({
        id: _parseInt(clientId.value),
        email: clientProfile.value.email,
        data: email,
        applicationId: (_applicationId$value2 = applicationId == null ? void 0 : applicationId.value) != null ? _applicationId$value2 : null
      });
      showToast("success", "emailSent");
    };
    const sendEmailButtonDisabled = computed(() => {
      return !textareaValue.value || textareaValue.value == "loading" || isErrorState.value;
    });
    const openPromptModal = async type => {
      var _aiEmailTemplateModal;
      if (type === "load" && !savedPrompts.value.length) {
        await loadSavedPrompts();
        if (!savedPrompts.value.length) {
          return;
        }
      }
      modalType.value = type;
      (_aiEmailTemplateModal = aiEmailTemplateModal.value) == null ? void 0 : _aiEmailTemplateModal.openModal(type);
    };
    const handleLoadPrompt = loadedPrompt => {
      customPrompt.value = loadedPrompt || "";
    };
    const closePromptModal = () => {
      var _aiEmailTemplateModal2;
      (_aiEmailTemplateModal2 = aiEmailTemplateModal.value) == null ? void 0 : _aiEmailTemplateModal2.closeModal();
    };
    return {
      modalOpened,
      modalType,
      generateEmailModal,
      aiEmailTemplateModal,
      textareaValue,
      purposeOptions,
      toneOptions,
      lengthOptions,
      languageOptions,
      selectedTone,
      selectedLength,
      selectedLanguage,
      selectedPurpose,
      loading,
      aiEmailDefaultSettings,
      openModal,
      closeModal,
      selectMailPurpose,
      handleGenerateEmail,
      handleSetDefault,
      handleButton,
      sendEmailButtonDisabled,
      customPrompt,
      openPromptModal,
      handleLoadPrompt,
      closePromptModal,
      loadSavedPrompts,
      savedPrompts,
      showLoadOption,
      savedPromptsLoading
    };
  }
});